import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-error-dialog-stop',
  templateUrl: './error-dialog-stop.component.html',
  styleUrl: './error-dialog-stop.component.scss'
})
export class ErrorDialogStopComponent {



  constructor(
    public _dialogRef: MatDialogRef<ErrorDialogStopComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDdialogData,
  ) {
   
  }
  
  


}

export interface IDdialogData{
dlgTitle: string;
dlgLine1: string;
dlgLine2: string;
}

